import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { SERVICE_CATEGORIES, waLink } from "../constants/site";
import { useLang } from "../i18n/LangContext";

const slugify = (text) =>
    text
        .toLowerCase()
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/(^-|-$)/g, "");

const Services = () => {
    const { t } = useLang();
    return (
    <section id="servicos" data-testid="services-section" className="wine-noir py-24 sm:py-32">
        <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12">
            <div className="flex flex-col justify-between gap-8 md:flex-row md:items-end">
                <SectionHeading
                    index={t.services.index}
                    eyebrow={t.services.eyebrow}
                    title={
                        <>
                            {t.services.titleA}<span className="italic text-gold">{t.services.titleB}</span>
                        </>
                    }
                />
                <Reveal delay={0.2}>
                    <p className="max-w-xs text-sm leading-relaxed text-taupe">
                        {t.services.side}
                    </p>
                </Reveal>
            </div>

            <div className="mt-16 grid gap-6 lg:grid-cols-2 lg:gap-8">
                {SERVICE_CATEGORIES.map((category, ci) => (
                    <Reveal key={category.title} delay={ci * 0.1}>
                        <div
                            data-testid={`service-category-${slugify(category.title)}`}
                            className="h-full rounded-3xl border border-burnt/20 bg-espresso/40 p-7 transition-colors duration-500 hover:border-gold/40 sm:p-9"
                        >
                            <div className="flex items-baseline justify-between gap-4">
                                <h3 className="font-serif text-2xl text-cream sm:text-3xl">
                                    {t.services.categories[ci].title}
                                </h3>
                                <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-burnt">
                                    {String(ci + 1).padStart(2, "0")}
                                </span>
                            </div>
                            <p className="mt-2 text-sm text-taupe">{t.services.categories[ci].note}</p>

                            <ul className="mt-7">
                                {category.items.map((item) => (
                                    <li key={item.name}>
                                        <a
                                            data-testid={`service-item-${slugify(item.name)}`}
                                            href={waLink(`Olá, Yasmim! Quero agendar: ${item.name}.`)}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="group flex items-baseline py-3"
                                        >
                                            <span className="text-sm text-beige transition-colors duration-300 group-hover:text-gold sm:text-base">
                                                {item.name}
                                            </span>
                                            <span className="mx-3 flex-1 border-b border-dotted border-beige/20 transition-colors duration-300 group-hover:border-gold/40" />
                                            <span
                                                data-testid={`service-price-${slugify(item.name)}`}
                                                className="font-serif text-lg text-cream transition-colors duration-300 group-hover:text-gold"
                                            >
                                                {item.price}
                                            </span>
                                            <ArrowUpRight className="ml-3 h-4 w-4 shrink-0 self-center text-burnt opacity-0 transition-all duration-300 group-hover:text-gold group-hover:opacity-100" />
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </Reveal>
                ))}
            </div>

            <Reveal delay={0.2}>
                <p className="mt-10 text-center font-mono text-[11px] uppercase tracking-[0.3em] text-taupe">
                    {t.services.footerNote}
                </p>
            </Reveal>
        </div>
    </section>
    );
};

export default Services;
